export interface LimitedValue {
    label: string;
    value: string;
}

export interface ValueRangeType {
    min: number;
    max: number;
}

export interface Guidance {
    exampleText: string;
    descriptionHtml: string;
    viewType?: string;
    viewTitle?: string;
    fieldName?: string;
}

export enum FieldComposerFieldType {
    String = "string",
    Integer = "integer",
    Year = "year",
    Place = "place",
    LimitedValues = "limitedValues",
    ValueRange = "valueRange",
}

export enum FieldComposerExactnessType {
    Generic = "generic",
    Year = "year",
    Place = "place",
}

type BaseFieldConfig = {
    label: string | React.ReactNode;
    placeholder?: string;
    required?: boolean;
    showExactness?: boolean;
    exactnessType?: FieldComposerExactnessType;
    guidance?: Guidance;
};

export type FieldComposerConfig =
    | (BaseFieldConfig & { fieldType: FieldComposerFieldType.String })
    | (BaseFieldConfig & { fieldType: FieldComposerFieldType.Integer })
    | (BaseFieldConfig & { fieldType: FieldComposerFieldType.Year })
    | (BaseFieldConfig & { fieldType: FieldComposerFieldType.Place })
    | (BaseFieldConfig & { fieldType: FieldComposerFieldType.LimitedValues; options: LimitedValue[] })
    | (BaseFieldConfig & { fieldType: FieldComposerFieldType.ValueRange; range: ValueRangeType });

export interface FieldComposerProps {
    fieldPath: string;
    fieldConfig: FieldComposerConfig;
    children: React.ReactNode;
    exactnessFieldPath?: string;
}
